import { render, staticRenderFns } from "./DelMongoDB.vue?vue&type=template&id=126d46cb&scoped=true&"
import script from "./DelMongoDB.vue?vue&type=script&lang=js&"
export * from "./DelMongoDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d46cb",
  null
  
)

export default component.exports